import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import { Component } from "@/decorators";
import RecompensaModel from "@/models/programafidelidade/recompensaModel";
import produtoService from "@/services/produto/produtoService";
import RecompensaService from "@/services/recompensaService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        decimalComponent,
        comboComponent,
        checkboxComponent,
    },
})
export default class RecompensaEditComponent extends EditComponentBase<RecompensaModel> {
    produtosOptions: Array<Object> = [];

    public async loadProdutos(refresh = false) {
        this.produtosOptions = await produtoService.comboCached(this.usuarioLogado.franquiaId, refresh);
    }

    private async beforeMount() {
        await this.setProps(new RecompensaService(), "recompensas", new RecompensaModel());

        this.loadProdutos();
    }
}
